// let url = 'http://www.corange.com/api'
let url = '/api'
export default {
    dev: {
        api: {
            recommendList: url + '/recommend/list',
            jobTypeList: url + '/jobtype/list',
            addressList: url + '/address/list',
            jobList: url + '/job/list',
            caseList: url + '/case/list',
            caseDetail: url + '/case/detail',
            statistics: url + '/statistics/update',
            infoList: url + '/info/list',
            infoDetail: url + '/info/detail',
        }
    }
}


// WEBPACK FOOTER //
// ./src/services/services.js